import { useMutation } from '@tanstack/react-query';
import type { StartFileExportResponse } from '@erp/rpc';
import { downloadFileExport } from './downloadFileExport';

/**
 * A server-side file export as a mutation: `start` asks for the export and
 * returns its background job; the mutation stays pending until that job has
 * built the file into blob storage and the browser has been handed its
 * download link.
 */
export function useFileExport<TInput>(
  start: (input: TInput) => Promise<StartFileExportResponse>,
) {
  return useMutation({
    mutationFn: async (input: TInput) => {
      const { backgroundJobId } = await start(input);
      return downloadFileExport(backgroundJobId);
    },
  });
}
